import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        background: ({color, selected}) => selected ? `linear-gradient(45deg, ${theme.palette[color].dark} 0%, ${theme.palette[color].main} 100%)` : theme.palette.common.white,
        paddingBottom: theme.spacing(2),
        borderBottomLeftRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2)
    },
});

const Footer = ({classes, color, ...props}) => {
    return (
        <div className={classes.root}/>
    );
};

Footer.propTypes = {
    color: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
};

Footer.defaultProps = {
    selected: false,
};

export default withStyles(styles)(Footer);
